import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a470e572"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MListaChips",
  "data-testid": "MListaChips"
}
const _hoisted_2 = {
  key: 0,
  class: "MListaChips__MaisChips",
  "data-testid": "MListaChips__MaisChips"
}

import Chip from "primevue/chip"
  import { withDefaults } from "vue"
  import { setup } from "./MListaChips"

  interface Props {
    chips: string[]
    exibirSomente?: number
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MListaChips',
  props: {
    chips: null,
    exibirSomente: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { chips: string[], exibirSomente: number }

  

  const { chipsVisiveis, numeroDeChipsAMais, propExibirSomenteValido } =
    setup(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chipsVisiveis), (label, i) => {
      return (_openBlock(), _createBlock(_unref(Chip), {
        key: i,
        class: "MListaChips__Chip",
        "data-testid": "MListaChips__Chip",
        label: label
      }, null, 8, ["label"]))
    }), 128)),
    (_unref(propExibirSomenteValido))
      ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString(_unref(numeroDeChipsAMais)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})